import { KeywordUsageModel } from "./keyword-usage";

export class TranscriptModel {
  // Server Fields
  id;
  session_device_id;
  start_time;
  length;
  question;
  transcript;
  word_count;
  direction;
  emotional_tone_value;
  analytic_thinking_value;
  clout_value;
  authenticity_value;
  certainty_value;
  keywords;
  speaker_tag;
  topic_id;
  speaker_id;
  speaker_metrics;
  // Diarization attribution confidence for this line (0-100), or null when the
  // speaker was not set by a fingerprint match (clustering fallback, or older
  // transcripts recorded before confidence was captured). contested lists the
  // voices that overlapped when the segment could not be cleanly attributed.
  speaker_confidence;
  contested;
  // True when this pod's microphone heard the speaker from the other side of
  // the table and named them from the partner pod's roster: shown muted on
  // this pod's page, counted for their own team in coding.
  far_side;

  static fromJson(json, speaker_metrics) {
    const model = new TranscriptModel();
    model.id = json["id"];
    model.session_device_id = json["session_device_id"];
    model.start_time = json["start_time"];
    model.length = json["length"];
    model.question = json["question"];
    model.transcript = json["transcript"];
    model.word_count = json["word_count"];
    model.direction = json["direction"];
    model.emotional_tone_value = json["emotional_tone_value"];
    model.analytic_thinking_value = json["analytic_thinking_value"];
    model.clout_value = json["clout_value"];
    model.authenticity_value = json["authenticity_value"];
    model.certainty_value = json["certainty_value"];
    model.speaker_tag = json["speaker_tag"];
    model.topic_id = json["topic_id"];
    model.speaker_id = json["speaker_id"];
    model.keywords = KeywordUsageModel.fromJsonList(json["keywords"]);
    model.keywords.forEach((k) => (k.transcript_id = model.id));
    model.speaker_metrics = speaker_metrics;
    const vf = json["voice_features"] || {};
    model.speaker_confidence =
      vf.confidence && typeof vf.confidence.percent === "number"
        ? vf.confidence.percent
        : null;
    model.contested = Array.isArray(vf.contested) ? vf.contested : null;
    model.far_side = !!(vf.confidence && vf.confidence.far_side === true);
    return model;
  }

  // Converts JSON to TranscriptModel[]
  static fromJsonList(jsonArray) {
    const transcripts = [];
    for (const el of jsonArray) {
      transcripts.push(TranscriptModel.fromJson(el));
    }
    return transcripts;
  }
}
